// Vue
import { defineStore } from 'pinia';

// Repository
import VendorRepository from '@/repositories/vendorRepository';

// Service
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';

// Store
//import { useCommonStore } from '@/stores/common/commonStore';
import { useLoginStore } from '@/stores/login/loginStore';

// Else
import i18n from '@/common/i18n';

export const useHeaderStore = defineStore({
    id: 'header',
    state: () => ({}),
    getters: {},
    actions: {
        /**
         * ベンダー取得API
         * @param {*} req
         * @returns response
         */
        async getVendorAction(req) {
            const vendorRepository = new VendorRepository();
            try {
                const response = await vendorRepository.getVendorApi(req);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        async logoutAction() {
            const loginStore = useLoginStore();

            // Cognitoログアウト処理
            await loginStore.cognitoLogoutAction();
        },
    },
});
